module.exports = __webpack_public_path__ + "img/newsmr.5f4f0810.png";